import { closeModalAction } from "../../Modal/reducer";
import { openNotification } from "../../Notification";
import { downloadFile } from "../../../utils/downloadFile";
import { MODAL_EXPORT_LOADING } from "./LoadingModal";

/**
 * Handles the successful response from an export API call.
 * Extracts the filename from the returned URL, triggers the browser download,
 * and closes the loading modal on both success and failure.
 *
 * @param {object}   res                             - Axios response (expects res.data.data.url)
 * @param {Function} dispatch                        - Redux dispatch function
 * @param {Function} trans                           - i18n translation function
 * @param {string}   [modalName=MODAL_EXPORT_LOADING] - Loading modal to close after download
 */
export const handleExportDownload = (res, dispatch, trans, modalName = MODAL_EXPORT_LOADING) => {
  const url = res.data.data.url;
  const fileName = url.substring(url.lastIndexOf("/") + 1, url.length);
  downloadFile({
    fileUrl: url,
    fileName,
    onSuccess: () => dispatch(closeModalAction({ name: modalName })),
    onFailed: () => {
      openNotification({ type: "error", message: trans("container.form_errors.internal_server_error") });
      dispatch(closeModalAction({ name: modalName }));
    }
  });
};

/**
 * Handles a failed export API call by showing an error notification and
 * closing the loading modal.
 *
 * @param {Function} dispatch                        - Redux dispatch function
 * @param {Function} trans                           - i18n translation function
 * @param {string}   [modalName=MODAL_EXPORT_LOADING] - Loading modal to close
 */
export const handleExportError = (dispatch, trans, modalName = MODAL_EXPORT_LOADING) => {
  openNotification({ type: "error", message: trans("container.form_errors.internal_server_error") });
  dispatch(closeModalAction({ name: modalName }));
};

export const prepareExportRequestParams = (exportColumns = [], columns = [], selectedRows = []) => {
  const langKeys = [];
  const filters = selectedRows.map((item) => item.id);

  exportColumns.forEach((item) => {
    const associatedColumn = columns.find((col) => col.dataIndex === item.column) || {};
    if (item.trans || associatedColumn.title) {
      langKeys.push({
        column: item.column,
        trans: item.trans || associatedColumn.title || ""
      });
    }
  });

  return {
    langKeys,
    columns: exportColumns.filter((item) => item.onlyLang !== true).map((item) => item.column),
    ...(filters.length > 0 ? { "filters[identifiers]": filters } : {})
  };
};
